<template>
  <div ref="temporary">
    <slot/>
  </div>
</template>

<script>
export default {
    name: 'GmapMarker',
    inject: ['map', 'markerService', 'openInfoWindow'],
    props: {
        position: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#3c4043'
        }
    },
    data: () => ({
        instance: null,
        content: null
    }),
    watch: {
        position (val) {
            this.markerService.unregister(this._uid)
            this.instance.setPosition(val)
            this.markerService.register(this._uid, val)
        },
        label (val) {
            this.instance.setLabel({ text: val, color: 'white' })
        },
        color (val) {
            this.instance.setIcon(this.genIcon(val))
        }
    },
    mounted () {
        this.content = this.$refs.temporary
        this.content.parentNode.removeChild(this.content)

        this.instance = new this.$google.maps.Marker({
            position: this.position,
            map: this.map,
            icon: this.genIcon(this.color),
            label: { text: this.label, color: 'white' }
        })
        this.markerService.register(this._uid, this.position)
        this.instance.addListener('click', this.onClick)
    },
    beforeDestroy () {
        this.markerService.unregister(this._uid)
        this.instance.setMap(null)
        this.$google.maps.event.clearListeners(this.instance, 'click')
    },
    methods: {
        onClick () {
            this.openInfoWindow(this.instance, this.content)
        },
        genIcon (color) {
            return {
                path: ' M 12,2 C 8.13,2 5,5.13 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.87 -3.13,-7 -7,-7 z',
                fillColor: color,
                fillOpacity: 1,
                strokeColor: 'white',
                strokeWeight: 1,
                scale: 1.7,
                anchor: new this.$google.maps.Point(12, 22),
                labelOrigin: new this.$google.maps.Point(12, 10)
            }
        }
    },
    render (h) {
        return h()
    }
}
</script>
